import axios from "axios";


const fetchFontAwesomeIcons = async () => {
  try {
    // Font Awesome provides a CSS file with all free icons
    const response = await axios.get(
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    );
    const iconRegex = /\.fa-([\w-]+):before/g;
    const matches = response.data.matchAll(iconRegex);
    const icons = Array.from(matches, (match) => match[1]);

    return icons.map((icon) => ({
      class: `fa-solid fa-${icon}`,
      icon_name: icon,
      cdn_name: "FontAwesome",
    }));
  } catch (error) {
    console.error("Error fetching Font Awesome icons:", error);
    return [];
  }
};

const fetchBootstrapIcons = async () => {
  try {
    const response = await axios.get(
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
    );
    const iconRegex = /\.bi-([\w-]+)::before/g;
    const matches = response.data.matchAll(iconRegex);
    const icons = Array.from(matches, (match) => match[1]);

    return icons.map((icon) => ({
      class: `bi bi-${icon}`,
      icon_name: icon,
      cdn_name: "Bootstrap",
    }));
  } catch (error) {
    console.error("Error fetching Bootstrap icons:", error);
    return [];
  }
};

// const fetchAllIcons = async () => {
//   try {
//     const [faIcons, bsIcons, matIcons] = await Promise.all([
//         fetchMaterialIcons(),
//         fetchBootstrapIcons(),
//         fetchFontAwesomeIcons(),
//     ]);

//     return [...faIcons, ...bsIcons, ...matIcons];
//   } catch (error) {
//     console.error("Error fetching icons:", error);
//     return [];
//   }
// };
const fetchAllIcons = async () => {
  try {
    const [bsIcons, faIcons] = await Promise.all([
      //   fetchMaterialIcons(),
      fetchBootstrapIcons(),
      fetchFontAwesomeIcons(),
    ]);
    // console.log("Material Icons:", matIcons.length);
    console.log("Bootstrap Icons:", bsIcons.length);
    console.log("Font Awesome Icons:", faIcons.length);
    return [...bsIcons, ...faIcons];
  } catch (error) {
    console.error("Error fetching icons:", error);
    return [];
  }
};
let icons_data = [];

export const iconsPromise = fetchAllIcons()
  .then((fetchedIcons) => {
    icons_data = fetchedIcons;
    return fetchedIcons;
  })
  .catch((error) => {
    console.error("Failed to fetch icons:", error);
    return [];
  });

export { icons_data };
